module.exports = __webpack_public_path__ + "static/media/galerija_2016 (10).2286e04b.jpg";